import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getUserRole, getJWTToken } from '../utils/auth';

export const ProtectedRoute = ({ component: Component, allowedRoles, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) => {
                const userRole = getUserRole();
                const jwtToken = getJWTToken();

                if (!allowedRoles) {
                    return <Component {...props} />;
                }

                if (!jwtToken) {
                    return <Redirect to="/login" />;
                }

                if (allowedRoles.includes(userRole)) {
                    return <Component {...props} />;
                }

                return <Redirect to="/unauthorized" />;
            }}
        />
    );
};
